exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".svg{fill:red !important;color:red !important;stroke:red !important}.navigatorPanel{display:-webkit-box;display:-ms-flexbox;display:flex}.navigatorPanel svg path{stroke:red !important;fill:red !important;color:red !important}.navigatorPanel__link{display:inline-block;color:#bababa;text-align:center;text-transform:uppercase;font-size:1rem;color:#606060;margin:0 1rem}.navigatorPanel__img{stroke:red !important;fill:red !important;color:red !important;height:2.5rem}.navigatorPanel__img--selected{stroke:red !important;fill:#404040 !important}.navigatorPanel__label{font-size:.8rem;display:block}\n", ""]);

// exports
